module.exports = __webpack_public_path__ + "img/qixi_activity_top.501b7864.jpg";